import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { getTableCells, methodResult, responseType } from '../../../utils/TableCells';
import { actions } from '../../modules/Actions';
import { addRowTotalAndColumnTotal, columnDisps, columnKeys, rowData, TableDataProps } from '../../../utils/NegotiationReducerUtils';
import { getReportTableRowKeys } from '../ReportTableRowReducer';
import _isEqual from 'lodash/isEqual';
import { actionViewColumns } from '../../../Common';



export const nextActionInitialState: TableDataProps = {
  // Stateの初期値
  header: columnKeys(actionViewColumns),
  headerDisp: columnDisps(actionViewColumns),
  data: rowData(),
};

function makingTableData(dtoToViewTable: methodResult, viewRow: string[]) {
  return {
    header: nextActionInitialState.header,
    headerDisp: nextActionInitialState.headerDisp,
    data: addRowTotalAndColumnTotal(dtoToViewTable, viewRow),
  };
}

export const NegotiationNextActionReducer = reducerWithInitialState(nextActionInitialState).case(
  actions.updateNegotiation.action,
  (state: TableDataProps, payload: responseType) => {
    const rowKeys = getReportTableRowKeys();
    const viewRowWithoutTotal = rowKeys.slice(1);
    const viewColumnsWithoutTotal = columnKeys(actionViewColumns).slice(0, -1);
    const tableCells = getTableCells(payload, viewColumnsWithoutTotal, viewRowWithoutTotal);
    const newState = makingTableData(tableCells, viewRowWithoutTotal);

    return _isEqual(state.data, newState.data) ? state : newState;
  }
);
